<template>
    <v-menu bottom offset-y transition="scale-transition" :nudge-right="icon ? 32 : 0">
        <v-text-field slot="activator"
            v-model="model"
            readonly
            :label="label"
            :prepend-icon="icon"
            :prepend-inner-icon="innerIcon"
            :hide-details="hideDetails"
            :clearable="clearable"
            @click:clear="clear"
            style="min-width: 10rem; max-width: 14rem;"
        ></v-text-field>
        <v-date-picker v-model="model"
            :min="min"
            :max="max"
            @input="changed"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'v-input-date-picker',
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        },
        innerIcon: {
            type: String,
            default: null
        },
        hideDetails: {
            type: [Boolean, String],
            default: 'auto'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        iso: {
            type: Boolean,
            default: false
        },
        min: {
            type: String,
            default: null
        },
        max: {
            type: String,
            default: new Date().toISOString().slice(0, 10)
        },
    },
    data() {
        return {
            model: null
        }
    },
    mounted() {
        //console.log('Mounted, value', this.value);
        this.model = this.value ? new Date(this.value).toISOString().slice(0, 10) : null;
    },
    watch: {
        value() {
            //console.log('Value changed outside', this.value);
            this.model = this.value ? new Date(this.value).toISOString().slice(0, 10) : null;
        }
    },
    methods: {
        clear() {
            this.model = null;
            this.changed();
        },
        changed() {
            let value = this.model
                ? (this.iso ? this.model : new Date(this.model).valueOf())
                : null;
            //console.log('Model changed', this.model, 'and emited', value);
            this.$emit('input', value);
        },
    }
}
</script>
